import { render, staticRenderFns } from "./pitcherList.vue?vue&type=template&id=66482ac0&scoped=true"
import script from "./pitcherList.vue?vue&type=script&lang=js"
export * from "./pitcherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66482ac0",
  null
  
)

export default component.exports